module.exports = __webpack_public_path__ + "img/role03.dd7eb273.png";